// extracted by css-extract-rspack-plugin
export default {"cell":"SegmentItem-module__cell___YcTTk"};